import {
  ButtonProps,
  Spinner,
  Button as UIKittenButton,
} from "@ui-kitten/components";
import { useAppSelector } from "hooks/useAppSelector";
import React from "react";
import { View, ViewStyle } from "react-native";

export interface CustomizedButtonProps extends ButtonProps {
  loading?: boolean;
}

const LoadingIndicator = () => (
  <View
    style={{
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Spinner size="small" style={{ borderColor: "white" }} />
  </View>
);

const Button: React.FC<CustomizedButtonProps> = ({
  loading,
  children,
  style,
  appearance = "filled",
  accessoryLeft,
  accessoryRight,
  ...otherProps
}) => {
  const tenantThemeColor = useAppSelector(
    (state) => state.tenant.tenantThemeColor
  );
  const shadowStyle: ViewStyle = {
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    backgroundColor: appearance === "outline" ? "#fff" : tenantThemeColor,
  };

  const shouldNotApplyShadow =
    appearance === "ghost" || loading || otherProps.disabled;

  return (
    <UIKittenButton
      {...otherProps}
      accessoryRight={accessoryRight}
      accessoryLeft={loading ? LoadingIndicator : accessoryLeft}
      disabled={loading || otherProps.disabled}
      appearance={appearance}
      // if button's appearance is set to ghost, don't apply shadow
      style={[
        shouldNotApplyShadow ? {} : shadowStyle,
        {
          borderRadius: 8,
        },
        style,
      ]}
    >
      {children}
    </UIKittenButton>
  );
};
export default Button;
